<template>
  <div class="wrapper">
      <div class="mt-7">
          <div class="content-title text-sm font-normal mt-5">样板房装修</div>
            <div class="flex items-center mt-4">
                <div class="screen-wrap" @click="pop_picker=true">
                    <div class="flex-1 van-ellipsis">{{ item.decorate==''?'请选择样板房装修':(item.decorate==1?'毛坯':'精装') }}</div>
                    <van-icon name="arrow-down" color="#666" size="12" />
                </div>
            </div>
          <div class="content-title text-sm font-normal mt-5">样板房名称</div>
          <div class="flex items-center mt-1 py-3.5 border-b">
            <input v-model="item.name" type="text" class="flex-1 text-sm" placeholder="请输入样板房名称">
            <img :src="require('assets/project/minus.png')" alt="" class="icon-xs" @click="minusHouse()">
          </div>
      </div>
      <van-action-sheet v-model="pop_picker">
        <van-picker
            :default-index="picker_active"
            show-toolbar
            :columns="decorateList"
            value-key="name"
            @confirm="onConfirm"
            @cancel="pop_picker=false"
        />
        </van-action-sheet>
  </div>
</template>

<script>
import { Icon, ActionSheet, Picker } from 'vant'
export default {
  components:{
    [Icon.name]:Icon,
    [ActionSheet.name]:ActionSheet,
    [Picker.name]:Picker,
  },
  props:["item","Index"],
  data(){
    return {
        pop_picker: false,
        decorateList: [{
            name: '毛坯',
            type:  1
        },{
            name: '精装',
            type:  2
        }],
        decorateName: '请选择样板房装修',
        picker_active: '',
    }
  },
  watch:{},
  computed:{},
  methods:{
    onConfirm(value) {
      this.decorateName = value.name
      this.picker_active = value.type
      this.item.decorate = value.type
      this.pop_picker = false
    },
    minusHouse() {
      this.$emit('back',this.Index)
    }
  },
  created(){},
  mounted(){}
}
</script>
<style scoped>
img{
   pointer-events:unset!important;
}
</style>